// extracted by mini-css-extract-plugin
export var previewContainer = "_sz-0";